import type { ToastManager } from "../Toast";
import { annotationStudioText, resolveAnnotationOperationErrorMessage } from "./messages";
import type { AnnotationOperationError, AnnotationStudioLocale } from "./types";
import { useStudioErrorToast } from "./useStudioErrorToast";

export function useAnnotationOperationErrorToast({
  manager,
  error,
  locale,
  suppressed = false,
}: {
  manager: ToastManager;
  error: AnnotationOperationError | null;
  locale: AnnotationStudioLocale;
  suppressed?: boolean;
}): void {
  const errorMessage = error
    ? (resolveAnnotationOperationErrorMessage(error, locale) ??
      annotationStudioText("operationFailed", locale))
    : null;

  useStudioErrorToast({
    manager,
    notification:
      error && errorMessage
        ? {
            // Driver instances are not stable identities. Product-owned operation/code plus the
            // resolved safe message form the semantic failure identity shown to the user.
            signature: JSON.stringify([error.operation, error.code, errorMessage]),
            message: errorMessage,
          }
        : null,
    suppressed,
  });
}
